module.exports = __webpack_public_path__ + "img/icon_map_11_off_010.00f6008e.png";